import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Indicators, chart with commissions and two link cards while "Seus links" loads. */
const AcquisitionSkeleton = () => (
  <Stack gap={3} aria-busy="true">
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
      }}
    >
      {Array.from({ length: 3 }, (_, index) => (
        <Skeleton key={index} variant="rounded" height={96} />
      ))}
    </Box>
    <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' } }}>
      <Skeleton variant="rounded" height={220} />
      <Skeleton variant="rounded" height={220} />
    </Box>
    <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
      <Skeleton variant="rounded" height={200} />
      <Skeleton variant="rounded" height={200} />
    </Box>
  </Stack>
);

export default AcquisitionSkeleton;
